// DAS-3189: the target of the LLM Advice "follows up alert #N" link, searched in the
// holdings' alerts AND the favorites alerts. A "Step In" on a stock you watch but do not
// hold lives in the favorites list; searching only the holdings' list called it "archived".
// DAS-3190: also the Opportunities alerts (scope 'Unknown': stocks you neither hold nor
// watch, e.g. the HRMY "Monitor" behind a BUY advice), the third list the link missed.
export default function findFollowedUpAlert(id, pfAlerts, favAlerts, oppAlerts) {
  const find = (list) => (Array.isArray(list) ? list.find(a => Number(a.ID) === Number(id)) : null);
  return find(pfAlerts) || find(favAlerts) || find(oppAlerts) || null;
}
